import { useState, useEffect, useCallback } from 'react'
import { monitorApi, type Project } from '@/lib/api/monitor'

/**
 * Shared hook that loads all solution groups and their projects.
 * Returns a flat list of projects across all groups, plus loading state.
 */
export function useAllProjects() {
  const [projects, setProjects] = useState<Project[]>([])
  const [groups, setGroups] = useState<any[]>([])
  const [loading, setLoading] = useState(false)

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const res: any = await monitorApi.getGroupList(1)
      const groupList = res?.data || res || []
      const groupArray = Array.isArray(groupList) ? groupList : []
      setGroups(groupArray)

      const allProjects: Project[] = []
      for (const group of groupArray) {
        try {
          const projRes: any = await monitorApi.getProjectList(group.group_id, 1)
          const projList = projRes?.data || projRes || []
          if (Array.isArray(projList)) {
            allProjects.push(...projList)
          }
        } catch {
          // skip failed group
        }
      }
      setProjects(allProjects)
    } catch (err) {
      console.error('Failed to load projects:', err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return { projects, groups, loading, reload: load }
}
